var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	2423: {
		fallback: () => (() => (__webpack_require__(8260))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@paldesk/module-federation/core",

	},
	5698: {
		fallback: () => (() => (__webpack_require__(3551))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "@paldesk/module-federation/remotes-registry",

	},
	63: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_map_js-node_modules_rxjs_dist_esm_inter-4171d7"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9e396b"), __webpack_require__.e("node_modules_rxjs_dist_esm_index_js")]).then(() => (() => (__webpack_require__(3393))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs",

	},
	9622: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_core_mjs")]).then(() => (() => (__webpack_require__(9460))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core",

	},
	3475: {
		fallback: () => (Promise.all([__webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_map_js-node_modules_rxjs_dist_esm_inter-4171d7"), __webpack_require__.e("default-node_modules_rxjs_dist_esm_internal_operators_auditTime_js-node_modules_rxjs_dist_esm-9e396b"), __webpack_require__.e("node_modules_rxjs_dist_esm_operators_index_js")]).then(() => (() => (__webpack_require__(3620))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "rxjs/operators",

	},
	6658: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc"), __webpack_require__.e("default-node_modules_angular_core_fesm2022__resource-chunk_mjs"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(9074))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/rxjs-interop",

	},
	2754: {
		fallback: () => (Promise.all([__webpack_require__.e("common"), __webpack_require__.e("node_modules_angular_core_fesm2022_primitives-signals_mjs")]).then(() => (() => (__webpack_require__(6699))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/signals",

	},
	6592: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_common_mjs")]).then(() => (() => (__webpack_require__(1352))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common",

	},
	6540: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_rxjs_rxjs"), __webpack_require__.e("default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators"), __webpack_require__.e("default-node_modules_angular_common_fesm2022_http_mjs")]).then(() => (() => (__webpack_require__(6613))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/common/http",

	},
	714: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop"), __webpack_require__.e("default-node_modules_ngrx_store_fesm2022_ngrx-store_mjs")]).then(() => (() => (__webpack_require__(1383))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/store",

	},
	6009: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_angular_common_http_angular_common_http"), __webpack_require__.e("default-node_modules_angular_platform-browser_fesm2022_platform-browser_mjs")]).then(() => (() => (__webpack_require__(8072))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/platform-browser",

	},
	6628: {
		fallback: () => (__webpack_require__.e("default-node_modules_angular_router_fesm2022_router_mjs").then(() => (() => (__webpack_require__(7415))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/router",

	},
	5311: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(784))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@core-features/core",

	},
	2139: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_effects_fesm2022_ngrx-effects_mjs").then(() => (() => (__webpack_require__(347))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/effects",

	},
	4511: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(8176))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@core-features/bridge",

	},
	3142: {
		fallback: () => (__webpack_require__.e("default-node_modules_ngrx_signals_fesm2022_ngrx-signals_mjs").then(() => (() => (__webpack_require__(1803))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@ngrx/signals",

	},
	7288: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_paldesk_module-federation_shared_paldesk_module-feder-cb240c"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(1704))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@paldesk/module-federation/header",

	},
	3641: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(8596))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@utils/interceptors",

	},
	712: {
		fallback: () => (__webpack_require__.e("common").then(() => (() => (__webpack_require__(8513))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@angular/core/primitives/di",

	},
	1668: {
		fallback: () => (Promise.all([__webpack_require__.e("default-webpack_sharing_consume_default_paldesk_module-federation_core_paldesk_module-federat-6a4597"), __webpack_require__.e("common")]).then(() => (() => (__webpack_require__(1743))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@paldesk/module-federation/shared",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [2423,5698];
__webpack_require__.federation.installInitialConsumes = (options) => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}))
__webpack_require__.consumesLoadingData.chunkMapping = {
	"main": [
		2423,
		5698
	],
	"default-webpack_sharing_consume_default_rxjs_rxjs": [
		63
	],
	"default-webpack_sharing_consume_default_angular_core_angular_core": [
		9622
	],
	"default-webpack_sharing_consume_default_rxjs_operators_rxjs_operators": [
		3475
	],
	"default-webpack_sharing_consume_default_angular_core_rxjs-interop_angular_core_rxjs-interop": [
		6658
	],
	"default-webpack_sharing_consume_default_angular_core_primitives_signals_angular_core_primitiv-a0f1dc": [
		2754
	],
	"default-webpack_sharing_consume_default_angular_common_angular_common": [
		6592
	],
	"default-webpack_sharing_consume_default_angular_common_http_angular_common_http": [
		6540
	],
	"default-webpack_sharing_consume_default_ngrx_store_ngrx_store": [
		714
	],
	"default-webpack_sharing_consume_default_angular_platform-browser_angular_platform-browser": [
		6009
	],
	"default-libs_shared-lib_features_messenger_src_index_ts-libs_shared-lib_features_root-store_s-fb8dc6": [
		6628,
		5311,
		2139
	],
	"apps_brochure-service_src_bootstrap_ts": [
		4511,
		3142,
		7288,
		3641
	],
	"default-node_modules_angular_core_fesm2022__resource-chunk_mjs": [
		712
	],
	"default-webpack_sharing_consume_default_paldesk_module-federation_shared_paldesk_module-feder-cb240c": [
		1668
	],
	"default-webpack_sharing_consume_default_paldesk_module-federation_core_paldesk_module-federat-6a4597": [
		2423
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}